module.exports = __webpack_public_path__ + "static/media/B3.f60c428c.png";